// app/javascript/controllers/select_slide_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "deck", "spread", "submitButton"]

  connect() {
    this.selectedDeckId = null;
    this.selectedSpreadId = null;
  }

  select(event) {
    const deckId = event.currentTarget.dataset.deckId;
    const spreadId = event.currentTarget.dataset.spreadId;

    if (deckId) {
      // Clear only the previous deck selection
      this.clearDeckSelections()

      // Update the selected deck
      this.selectedDeckId = deckId
      this.deckTarget.value = deckId

      // Add the indigo border to the selected deck
      event.currentTarget.classList.add('border-4', 'border-indigo-500')
    } else if (spreadId) {
      // Clear only the previous spread selection
      this.clearSpreadSelections()

      // Update the selected spread
      this.selectedSpreadId = spreadId
      this.spreadTarget.value = spreadId

      // Add the indigo border to the selected spread
      event.currentTarget.classList.add('border-4', 'border-indigo-500')
    }

    console.log("this.selectedDeckId " + this.selectedDeckId);
    console.log("this.selectedSpreadId " + this.selectedSpreadId)
  }

  clearDeckSelections() {
    // Remove the indigo border from all deck elements
    document.querySelectorAll("[data-deck-id]").forEach(element => {
      element.classList.remove('border-4', 'border-indigo-500')
    })
  }

  clearSpreadSelections() {
    // Remove the indigo border from all spread elements
    document.querySelectorAll("[data-spread-id]").forEach(element => {
      element.classList.remove('border-4', 'border-indigo-500')
    })
  }

  clearSelections() {
    // Remove indigo border from all deck and spread options
    const deckSlides = this.deckTargets;
    const spreadSlides = this.spreadTargets;

    deckSlides.forEach((slide) => {
      slide.classList.remove('border-4', 'border-indigo-500');
    });

    spreadSlides.forEach((slide) => {
      slide.classList.remove('border-4', 'border-indigo-500');
    });

    // Reset selected IDs
    this.selectedDeckId = null;
    this.selectedSpreadId = null;
    this.deckTarget.value = '';
    this.spreadTarget.value = '';
  }

  submitForm(event) {
    event.preventDefault();
    if (this.selectedDeckId && this.selectedSpreadId) {
      this.formTarget.submit();
    } else {
      alert("Please select both a deck and a spread before submitting.");
    }
  }
}

